import { type ReactNode, createContext, useContext, useMemo } from 'react';

interface DocumentNavigationContextValue {
  buildDocumentHref: (documentId: string) => string;
}

const defaultValue: DocumentNavigationContextValue = {
  buildDocumentHref: (documentId: string) =>
    `/collaborativeDocuments/${documentId}`,
};

const DocumentNavigationContext =
  createContext<DocumentNavigationContextValue>(defaultValue);

export const DocumentNavigationProvider = ({
  children,
  buildDocumentHref,
}: {
  children: ReactNode;
  buildDocumentHref: (documentId: string) => string;
}) => {
  const value = useMemo(() => ({ buildDocumentHref }), [buildDocumentHref]);

  return (
    <DocumentNavigationContext.Provider value={value}>
      {children}
    </DocumentNavigationContext.Provider>
  );
};

export const useDocumentNavigation = (): DocumentNavigationContextValue =>
  useContext(DocumentNavigationContext);
